import script from "./FreeProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeProduct.vue?vue&type=script&setup=true&lang=js"

import "./FreeProduct.vue?vue&type=style&index=0&id=046e0417&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046e0417"]])

export default __exports__